import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const BallIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C9.1 16 10 15.1 10 14H6C6 15.1 6.9 16 8 16ZM14 11C13.45 11 13 10.55 13 10V6C13 3.57 11.27 1.55 8.98 1.1C8.98 1.06 9 1.04 9 1C9 0.45 8.55 0 8 0C7.45 0 7 0.45 7 1C7 1.04 7.02 1.06 7.02 1.1C4.73 1.55 3 3.57 3 6V10C3 10.55 2.55 11 2 11C1.45 11 1 11.45 1 12C1 12.55 1.45 13 2 13H14C14.55 13 15 12.55 15 12C15 11.45 14.55 11 14 11Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default BallIcon;
